<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
        <input-form-text textInput="Título" :required="true" v-model="form.titulo" :value="form.titulo"></input-form-text>
		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right" for="descricao"> Descrição</label>
			<div class="col-sm-6">
				<textarea class="form-control" v-model="form.descricao" placeholder="Descrição" v-autosize></textarea>
			</div>
		</div>
        <input-form-text textInput="URL Youtube" :required="true" v-model="url" :value="url" v-debounce:1000ms="get_video_id"></input-form-text>
        <div class="form-group" v-if="urlImg">
          <label class="col-sm-3 control-label no-padding-right">Imagem</label>
          <div class="col-sm-9"><a :href="url" target="_blank"><img class="h-48" :src="urlImg"/></a></div>
        </div>
        <input-form-text textInput="Chave Youtube" disabled="disabled" :value="form.url"></input-form-text>
        <div class="form-group">
          <select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
        </div>
      </div>
    </div>
    <footer-button :disabled="isActive"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Multimídias',
			form: {
				titulo: '',
				descricao: '',
				url: '',
				ativo: '1'
			},
			url: '',
			urlImg: '',
			isActive: false,
			textMatch: null
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				await req(`/v1/multimidias/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/multimidias')
				
			} else {
				await req('/v1/multimidias', 'post', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/multimidias')
			}
			this.isActive = false
		},
		get_video_id() {
			let input = this.url
			if(!input) return
			// eslint-disable-next-line no-useless-escape
			let textMatch = input.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&]{10,12})/)
			if(!textMatch) return
			this.urlImg = `http://img.youtube.com/vi/${textMatch[1]}/hqdefault.jpg`
			this.form.url = textMatch[1]
		},
		async setVersion() {
			await req('/versao/1', 'put', {
				title: Date.now()
			})
		},
		async getDados() {
			const resp = await req(`/v1/multimidias/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.ativo = resp.ativo
			this.form.titulo = resp.titulo
			this.form.descricao = resp.descricao
			this.form.url = resp.url
			this.url = resp.url ? `https://www.youtube.com/embed/${resp.url}` : ''
			this.urlImg = resp.url ? `http://img.youtube.com/vi/${resp.url}/hqdefault.jpg` : ''
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
